import { render } from "./Folders.vue?vue&type=template&id=099c8dd4&scoped=true"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-099c8dd4"

export default script